const setupFooter = () => {
  const toggleEl = document.querySelector('.arjo-o-eshop-footer__motto-toggle');
  const mottoEl = document.querySelector('.arjo-o-eshop-footer__motto');

  if (!toggleEl || !mottoEl) {
    return;
  }

  toggleEl.addEventListener('click', () => {
    mottoEl.classList.toggle('expanded');
  })
}

setupFooter();

export { }